<template>
  <div style="margin-bottom: 45px;">
    <van-nav-bar :title="'客户列表('+$store.state.customer.state.count+')'" @click-right="onClickRight" fixed>
      <van-icon name="search" slot="right" />
    </van-nav-bar>
    <!--客户列表 开始-->
    <list-customer style="margin-top: 45px;"></list-customer>
    <!--客户列表 结束-->

    <van-icon class="main-button main-button-top" name="add-o" v-on:click="customerCreate"/>
    <van-icon class="main-button main-button-bottom" name="point-gift"  v-on:click="customerRandom"/>
  </div>
</template>

<script>
    import ListCustomer from '../../components/list-customer'
    export default {
      components:{
        ListCustomer
      },
      data() {
        return {
        };
      },
      beforeRouteLeave(to, from, next) {
        let position = window.scrollY  //记录离开页面的位置
        if (position == null) position = 0
        this.$store.commit('changeRecruitScrollY', position) //离开路由时把位置存起来
        next()
      },
      watch: {
        '$route' (to, from) {
          if (to.name === 'customer') {//跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
            let recruitScrollY = this.$store.state.recruitScrollY
            window.scroll(0, recruitScrollY)
          }
        }
      },
      methods: {
        customerRandom(){//摇一摇
          this.$api.post('/api/customer/random', null,
            data => {
              if(!data.mobile){
                let message = "客户池已经没有客户"
                this.$dialog.confirm({
                  title: '摇一摇',
                  message: message,
                })
              }else {
                let message = "姓名："+data.name+"<br/>手机号："+data.mobile+"<br/>"+data.message
                this.$dialog.confirm({
                  title: '摇一摇',
                  message: message,
                  confirmButtonText:"已接听",
                  cancelButtonText:"无人接"
                }).then(() => {
                  // on confirm
                  this.$dialog.confirm({
                    title: '客户意向确认',
                    message: "点击有意向将会跳入到跟进页面进行客户的跟进记录",
                    confirmButtonText:"有意向",
                    cancelButtonText:"无意向"
                  }).then(() => {
                    // on confirm 有意向
                    this.$api.post('/api/customer/update-tend-status', {
                      id: data.id,
                      tend_status:10,
                    },cus => {
                      if(cus.isMy){
                        this.$router.push('/customer/edit/'+cus.customer_id+'/customer');
                      }else {
                        this.$router.push('/customer/edit/'+cus.customer_id+'/random');
                      }
                    })
                  }).catch(() => {
                    // on cancel 无意向
                    this.$api.post('/api/customer/update-tend-status', {
                      id: data.id,
                      tend_status:20,
                    }, cus => {
                    })
                  });
                }).catch(() => {
                  // on cancel 无人接
                  this.$api.post('/api/customer/update-tend-status', {
                    id: data.id,
                    tend_status:99,
                  }, cus => {
                  })
                });
              }
            })
        },
        customerCreate(){
          this.$router.push('/customer/check');
        },
        onClickLeft() {
          this.$router.push('/');
        },
        onClickRight() {
          this.$router.push('/customer/search');
        },
      },
      created:function(){
        //获取下拉条件
        if(!this.$store.state.customer.state.options.status){
          this.$api.post('/api/base/options',null,
            r => {
              this.$store.state.customer.state.options = r.data
            }
          )
        }
      },
    }
</script>

<style scoped>
  .main-button {
    position: fixed;
    border-radius: 50%;
    background-color: #26a2ff;
    width: 60px;
    height: 60px;
    font-size: 2em;
    line-height: 60px;
    color: #fff;
    text-align: center;
  }
  .main-button-top {
    bottom: 130px;
    right: 30px;
  }
  .main-button-bottom {
    bottom: 60px;
    right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/index.vue